import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';

function ChatUsageTable({ sortedChatUsage, sortConfig, handleSort }) {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              onClick={() => handleSort('promptName')}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              Prompt Name {sortConfig.key === 'promptName' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('usage_1')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Usage (1d) {sortConfig.key === 'usage_1' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('usage_7')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Usage (7d) {sortConfig.key === 'usage_7' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('usage_30')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Usage (30d) {sortConfig.key === 'usage_30' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('cost_1')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Total Cost (1d) {sortConfig.key === 'cost_1' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('cost_7')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Total Cost (7d) {sortConfig.key === 'cost_7' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('cost_30')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Total Cost (30d) {sortConfig.key === 'cost_30' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('tokens_1')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Total Token Count (1d) {sortConfig.key === 'tokens_1' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('tokens_7')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Total Token Count (7d) {sortConfig.key === 'tokens_7' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
            <TableCell align="right" onClick={() => handleSort('tokens_30')} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Total Token Count (30d) {sortConfig.key === 'tokens_30' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedChatUsage.map(row => (
            <TableRow key={row.promptName}>
              <TableCell>{row.promptName}</TableCell>
              <TableCell align="right">{row.intervals['1']?.usage ?? 0}</TableCell>
              <TableCell align="right">{row.intervals['7']?.usage ?? 0}</TableCell>
              <TableCell align="right">{row.intervals['30']?.usage ?? 0}</TableCell>
              <TableCell align="right">{row.intervals['1']?.totalCost !== undefined ? `$${row.intervals['1'].totalCost.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })}` : '$0.0000'}</TableCell>
              <TableCell align="right">{row.intervals['7']?.totalCost !== undefined ? `$${row.intervals['7'].totalCost.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })}` : '$0.0000'}</TableCell>
              <TableCell align="right">{row.intervals['30']?.totalCost !== undefined ? `$${row.intervals['30'].totalCost.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })}` : '$0.0000'}</TableCell>
              <TableCell align="right">{row.intervals['1']?.totalTokenCount?.toLocaleString() ?? 0}</TableCell>
              <TableCell align="right">{row.intervals['7']?.totalTokenCount?.toLocaleString() ?? 0}</TableCell>
              <TableCell align="right">{row.intervals['30']?.totalTokenCount?.toLocaleString() ?? 0}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ChatUsageTable;
